import { svgCheck } from "./conversion-flow.svgs.js";
import cartState from "./conversion-flow.cart-state.js";
import {
  resolveVariantFresh,
  mergeQuizAnswersWithQueryParams,
} from "./conversion-flow.resolve-variant.js";

const svgChevronDown = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down" role="presentation"><polyline points="6 9 12 15 18 9"></polyline></svg>`;

class CFBuyCardFresh extends HTMLElement {
  #variants;
  #currentVariantData;
  #quantity = 1;

  #suggestedProduct;
  #elementPriceDisplay;
  #elementOriginalPriceDisplay;
  #elementCheckbox;
  #elementSelect;

  constructor() {
    super();
    this.#variants = JSON.parse(this.dataset.variants);
  }

  connectedCallback() {
    const quizAnswers = mergeQuizAnswersWithQueryParams(
      Shopify.designMode
        ? { weight: this.dataset.previewWeight }
        : QuizStorage.getQuizAnswers(),
    );
    const { product, suggestedProduct } = resolveVariantFresh(
      this.#variants,
      quizAnswers,
    );
    this.#currentVariantData = product;
    this.#suggestedProduct = suggestedProduct;
    this.#quantity = 1;
    this.render();
    this.updateCta();
  }

  render() {
    const images = JSON.parse(this.dataset.images);
    const title = this.dataset.title;
    const cardLabel = this.dataset.cardLabel || "Base Fresca";
    const imageSrc = images[0] ?? "";

    const options = this.#variants
      .map((v) => `<option value="${v.id}">${v.title}</option>`)
      .join("");

    const bullet_points = (
      this.#currentVariantData.metafields?.bullet_points ?? []
    )
      .map(
        (text) =>
          html` <div class="body-list-item">
            <div class="bullet-point">${svgCheck}</div>
            <span class="list-item-text">${text}</span>
          </div>`,
      )
      .join("");

    const original_price = this.#currentVariantData.price;
    const price =
      this.#currentVariantData.selling_plan_allocations?.[0]?.price ??
      this.#currentVariantData.price;
    const shouldShowOriginalPrice = original_price != price;

    this.innerHTML = html`
      <div class="product-card" for="buy-card-fresh">
        <div class="product-card-header">
          <span class="title">${cardLabel}</span>
          <span class="original-price">
            ${shouldShowOriginalPrice
              ? `€${(original_price / 100).toFixed(2).replace(".", ",")}`
              : ""}
          </span>
          <span class="price"
            >€${(price / 100).toFixed(2).replace(".", ",")}</span
          >
          <label class="check">
            <input type="checkbox" checked="true" style="display:none;" />
            ${svgCheck}
          </label>
        </div>

        <div class="product-card-body">
          <div class="product-card-details">
            <span class="body-title">${title}</span>
            <span class="body-subtitle"
              >${this.#currentVariantData.metafields?.subtitle ?? ""}</span
            >
            <div class="body-list">${bullet_points}</div>
          </div>
          <div class="product-image">
            <img src="${imageSrc}" alt="${title}" />
          </div>
        </div>

        <div class="product-card-footer">
          <div class="size-selector-row">
            <select class="size-select" role="listbox">
              ${options}
            </select>
            <div class="size-select-chevron">${svgChevronDown}</div>
          </div>
          <span class="suggested-amount">
            Cantidad recomendada para 1 mes de alimentación:
            ${this.#suggestedProduct.title}
          </span>
        </div>
      </div>
    `;

    this.#elementPriceDisplay = this.querySelector(
      ".product-card .product-card-header .price",
    );
    this.#elementOriginalPriceDisplay = this.querySelector(
      ".product-card .product-card-header .original-price",
    );
    this.#elementCheckbox = this.querySelector("input[type=checkbox]");
    this.#elementSelect = this.querySelector(".size-select");
    this.#elementSelect.value = this.#currentVariantData.id;
    this.#elementSelect.addEventListener(
      "change",
      this.onSelectChange.bind(this),
    );

    this.querySelector(".size-select-chevron").addEventListener(
      "click",
      (ev) => {
        ev.preventDefault();
        this.#elementSelect.showPicker();
      },
    );

    this.#elementCheckbox.addEventListener(
      "change",
      this.onCheckboxChange.bind(this),
    );
  }

  onSelectChange(ev) {
    const variantId = +ev.target.value;
    this.#currentVariantData = this.#variants.find((v) => v.id === variantId);

    const price =
      this.#currentVariantData.selling_plan_allocations?.[0]?.price ??
      this.#currentVariantData.price;
    const original_price = this.#currentVariantData.price;
    const shouldShowOriginalPrice = original_price !== price;
    this.#elementPriceDisplay.textContent = `€${((this.#currentVariantData.selling_plan_allocations?.[0]?.price ?? this.#currentVariantData.price) / 100).toFixed(2).replace(".", ",")}`;
    this.#elementOriginalPriceDisplay.textContent = shouldShowOriginalPrice
      ? `€${(original_price / 100).toFixed(2).replace(".", ",")}`
      : "";
    this.updateCta();
  }

  onCheckboxChange() {
    this.updateCta();
  }

  updateCta() {
    const original_price = this.#currentVariantData.price;
    const price =
      this.#currentVariantData.selling_plan_allocations?.[0]?.price ??
      this.#currentVariantData.price;
    cartState.update("FRESH", {
      checked: this.#elementCheckbox.checked,
      original_price: original_price * this.#quantity,
      price: price * this.#quantity,
      quantity: this.#quantity,
      variantId: this.#currentVariantData.id,
      selling_plan:
        this.#currentVariantData.selling_plan_allocations?.[0]?.selling_plan_id,
    });
  }
}

if (!customElements.get("cf-buy-card-fresh")) {
  customElements.define("cf-buy-card-fresh", CFBuyCardFresh);
}
